import { Flex, FlexProps, useTheme, Img } from "@xcorejs/ui";
import { ReactNode } from "react";
import styled from "styled-components";
import { XcoreTheme } from "./theme";

export type IconBoxProps = {
  icon?: ReactNode | string | null;
  fillWhite?: boolean;
} & FlexProps;

export const IconBoxStyle = styled(Flex)<IconBoxProps>``;

IconBoxStyle.defaultProps = {
  justifyContent: "center",
  alignItems: "center",
};

const IconBox = ({ icon, fillWhite, _icon, ...props }: IconBoxProps) => {
  const theme = useTheme() as XcoreTheme;
  const iconBoxProps = theme.iconBox;

  return (
    <IconBoxStyle {...iconBoxProps} {...props}>
      {icon &&
        (typeof icon === "string" ? (
          <Img src={icon} alt={icon} style={{ filter: fillWhite ? "brightness(0) saturate(100%) invert(1)" : "" }} />
        ) : (
          icon
        ))}
    </IconBoxStyle>
  );
};

IconBox.displayName = "IconBox";

export default IconBox;
